function Dot() {
  return(
    <div className="dot">●</div>
  )
}

export default Dot;